import { arrivalTimes } from './arrivalTimes';
import { baseSpaDay } from './baseSpaDay';
import { extras } from './extras';
import { inclusionsWithTimes } from './inclusions';

// Spa Package with arrival times, time slots supported but not required, and no choices
export const scenario2 = {
  ...baseSpaDay,
  ...arrivalTimes,
  configurationGroupsRequireTimeslots: false,
  configurationGroupsSupportTimeslots: true,
  configurationGroups: [...inclusionsWithTimes, ...extras],
};
